import React, {useState} from 'react'
import styled from '@emotion/styled'

import {Flag} from '@vio/atlas/Flag'
import {Icon} from '@vio/atlas/Icon'
import {Text} from '@vio/atlas/Text'
import {cssTheme} from '@vio/atlas/themes'
import {FormattedMessageWrapper} from '@vio/core/src/localization/components/FormattedMessage'
import {getCountryCodeFromLanguage} from '@vio/core/src/localization/services/country'
import {getLanguageConfig} from '@vio/core/src/localization/services/locale'
import {LanguageType} from '@vio/core/src/localization/types/LanguageType'

import {LanguageCurrencySelector} from '../../../../search/LanguageCurrencySelector'
import {Label, StyledListItem} from '../commonStyles'

const StyledFlag = styled(Flag)`
  margin-right: ${cssTheme.layout.spacing.s300};
`

const StyledText = styled(Text)`
  max-width: 200px; /*fixed width to prevent pushing longer elements*/
  text-overflow: ellipsis;
  overflow: hidden;
  text-wrap: nowrap;
`

type Props = {
  /** List of languages to be displayed */
  availableLanguages: LanguageType[]
  /** The currently selected value */
  currentLanguage: string
  /** The callback for when a currency is selected. The new currency code will be passed. */
  onChangeLanguage: (code: string) => void
  /** The callback when language input is clicked */
  onClickLanguage?: () => void
}

export const MobileLanguageSelector = ({
  availableLanguages,
  currentLanguage,
  onChangeLanguage,
  onClickLanguage
}: Props) => {
  const [isLanguageSelectorOpen, setLanguageSelectorOpen] = useState(false)

  const handleClick = () => {
    if (onClickLanguage) onClickLanguage()
    setLanguageSelectorOpen(true)
  }

  const flagIcon: string = getCountryCodeFromLanguage(currentLanguage)
  const languageConfig = getLanguageConfig(currentLanguage) as LanguageType

  const languageLabel =
    languageConfig?.displayName || currentLanguage.toUpperCase()

  return (
    <>
      <StyledListItem
        hasDivider
        as="button"
        onClick={handleClick}
        prefix={<Icon name="Language" />}
        title={
          <Text variant="labelM">
            <FormattedMessageWrapper
              id="languageLabel"
              defaultMessage="Language"
            />
          </Text>
        }
        suffix={
          <Label>
            <StyledFlag size={22} countryCode={flagIcon} />
            <StyledText variant="labelM">{languageLabel}</StyledText>
          </Label>
        }
      />

      <LanguageCurrencySelector
        isMobile
        initialSelector="language"
        isOpen={isLanguageSelectorOpen}
        onClose={() => setLanguageSelectorOpen(false)}
        availableLanguages={availableLanguages}
        selectedLanguage={currentLanguage}
        onChangeLanguage={onChangeLanguage}
        hasCurrency={false}
        availableCurrencies={[]}
        selectedCurrency=""
        onChangeCurrency={() => ({})}
      />
    </>
  )
}
